var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        {},
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("p", {
                    staticClass: "watermark",
                    domProps: { innerHTML: _vm._s(_vm.data.misc.watermark) }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.data.login.loginText) }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm" }, [
                      _c("label", {
                        staticClass: "text-nowrap",
                        attrs: { for: "ssn" },
                        domProps: { innerHTML: _vm._s(_vm.data.login.ssnLabel) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm" }, [
                      _vm.showSsnHelp && !_vm.isPhone
                        ? _c("small", { staticClass: "text-nowrap" }, [
                            _c("strong", [_vm._v("Format: YYYYMMDDXXXX")])
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ssn,
                        expression: "ssn"
                      }
                    ],
                    ref: "ssn",
                    staticClass: "form-control text-center form-control-lg ssn",
                    attrs: {
                      type: "text",
                      name: "ssn",
                      autocomplete: "nope",
                      autocapitalize: "none",
                      inputmode: "numeric",
                      placeholder: "YYYYMMDDXXXX",
                      disabled: _vm.cnmbr !== null && _vm.cnmbr.length > 0
                    },
                    domProps: { value: _vm.ssn },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.enterKeyHandler()
                      },
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.ssn = $event.target.value
                        },
                        function($event) {
                          return _vm.handleSsn($event.target.value)
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm" }, [
                      _c("label", {
                        staticClass: "text-nowrap",
                        attrs: { for: "cnmbr" },
                        domProps: {
                          innerHTML: _vm._s(_vm.data.login.cnmbrLabel)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm" }, [
                      _vm.showCnmbrHelp && !_vm.isPhone
                        ? _c("small", { staticClass: "text-nowrap" }, [
                            _c("strong", [_vm._v("Format: YYYYMMDD(+60)XXXX")])
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.cnmbr,
                        expression: "cnmbr"
                      }
                    ],
                    ref: "cnmbr",
                    staticClass: "form-control text-center form-control-lg ssn",
                    attrs: {
                      type: "text",
                      name: "cnmbr",
                      autocomplete: "nope",
                      autocapitalize: "none",
                      inputmode: "numeric",
                      placeholder: "YYYYMMDDXXXX",
                      disabled: _vm.ssn !== null && _vm.ssn.length > 0
                    },
                    domProps: { value: _vm.cnmbr },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.enterKeyHandler()
                      },
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.cnmbr = $event.target.value
                        },
                        function($event) {
                          return _vm.handleCnmbr($event.target.value)
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-group",
                      attrs: { role: "group", "aria-label": "" }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-login btn-sm",
                          attrs: {
                            disabled: !_vm.isSsnValid && !_vm.isCnmbrValid
                          },
                          on: {
                            click: function($event) {
                              return _vm.loginWithBankId()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.data.misc.loginBankidBtn) +
                              "\n            "
                          ),
                          _c("img", {
                            staticClass: "login-type",
                            attrs: {
                              src: require("@/assets/img/bankid.svg?data"),
                              alt: "BankID logotyp"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix--btns" }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-login btn-sm",
                          attrs: {
                            disabled: !_vm.isSsnValid && !_vm.isCnmbrValid
                          },
                          on: {
                            click: function($event) {
                              return _vm.loginWithFreja()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.data.misc.loginFrejaidBtn) +
                              "\n            "
                          ),
                          _c("img", {
                            staticClass: "login-type",
                            attrs: {
                              src: require("@/assets/img/freja.svg?data"),
                              alt: "Freja eID logotyp"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix--min" }),
                  _vm._v(" "),
                  _c("small", {
                    staticClass: "text-muted",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.login.loginDisclaimer)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix--min" }),
                  _vm._v(" "),
                  _c(
                    "alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.alert,
                          expression: "alert"
                        }
                      ],
                      staticClass: "alert alert-danger"
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.data.error.errorText)
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: { id: "more-info", role: "dialog", tabindex: "-1" }
            },
            [
              _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "data-dismiss": "modal" }
                      },
                      [_vm._v("×")]
                    ),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.login.moreInfoModal)
                      }
                    })
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: { id: "data-protection", role: "dialog", tabindex: "-1" }
            },
            [
              _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "data-dismiss": "modal" }
                      },
                      [_vm._v("×")]
                    ),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.login.dataProtectionModal)
                      }
                    })
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "vue-cookie-accept-decline",
            {
              ref: "cookies",
              attrs: {
                elementId: "cookies",
                debug: false,
                position: "top-left",
                type: "floating",
                disableDecline: true,
                transitionName: "slideFromBottom",
                showPostponeButton: false
              }
            },
            [
              _c("div", { attrs: { slot: "message" }, slot: "message" }, [
                _vm._v("\n      Denna sida använder cookies. "),
                _c("br"),
                _vm._v("\n      Läs mer "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.pts.se/cookies",
                      target: "_blank"
                    }
                  },
                  [_vm._v("här")]
                ),
                _vm._v(".\n    ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "acceptContent" }, slot: "acceptContent" },
                [_vm._v("Jag förstår")]
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 